// @ts-strict-ignore
import React from 'react';
import { DateTimeRange, RangeField } from '@/hybrid/core/DateTimeRange.molecule';
import { ValidatingFormComponent } from '@/hybrid/formbuilder/formBuilder.module';
import moment from 'moment-timezone';
import { Field, useForm } from 'react-final-form';
import { getFormFieldProps, getValidationFunction } from '@/hybrid/formbuilder/formbuilder.utilities';
import { Timezone } from '@/datetime/timezone.service';
import { useShowError } from '@/hybrid/formbuilder/hooks/useShowError';
import { FormFieldWrapper } from '@/hybrid/formbuilder/FormFieldWrapper';

export interface DateTimeRangeIF extends ValidatingFormComponent<RangeField<moment>> {
  component: 'DateTimeRangeFormComponent';
  hideTimezone?: boolean;
  fieldIdentifier?: RangeField<string>;
  timezone: Timezone;
  onStartTimeChange?: (value: moment) => void;
  onEndTimeChange?: (value: moment) => void;
  disabled?: boolean;
}

export const DateTimeRangeFormComponent: React.FunctionComponent<DateTimeRangeIF> = (props) => {
  const {
    label,
    name,
    testId = 'dateTimeRange',
    extraClassNames,
    value,
    hideTimezone,
    fieldIdentifier,
    timezone,
    customErrorText,
    extendValidation,
    validation,
    onStartTimeChange,
    onEndTimeChange,
    disabled,
  } = props;

  const formState = useForm().getState();
  const { showError, setShowError } = useShowError(false);

  const defaultValidation = (value: RangeField<moment>) =>
    !value || !value.start || !value.end || value.start.isAfter(value.end);
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  return (
    <FormFieldWrapper
      testId={testId}
      label={label}
      extraClassNames={extraClassNames}
      showError={showError}
      customErrorText={customErrorText}>
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const { showError, onChange } = getFormFieldProps(formState, input, meta, props);
          setShowError(showError);

          return (
            <DateTimeRange
              startTime={value.start}
              endTime={value.end}
              onChange={onChange}
              onStartTimeChange={onStartTimeChange}
              onEndTimeChange={onEndTimeChange}
              hideTimezone={hideTimezone}
              fieldIdentifier={fieldIdentifier}
              timezone={timezone}
              disabled={disabled}
            />
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};
